module.exports = __webpack_public_path__ + "img/gwnu_gallery7.6cd32e0e.jpg";